import { h } from 'preact';
export default (function (_ref) {
  var i18n = _ref.i18n;
  return h("div", {
    className: "uppy-Provider-loading"
  }, h("span", null, i18n('loading')));
});